import { render, staticRenderFns } from "./ReferralEquipments.vue?vue&type=template&id=f0dff8a2"
import script from "./ReferralEquipments.vue?vue&type=script&lang=js"
export * from "./ReferralEquipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports